const moment 		= require('moment')
const utils 		= require('../../../lib/utils')
const AirDatepicker = require('air-datepicker').default
const airDatepickerLocales = {
	de: require('air-datepicker/locale/de').default
}

// TODO: period-air.js usage: duration change => toDate change => steppingCorrection => toDateChange => durationChange leads to two form changes (once by period-air and once by air-datetime-picker)

/*
	### instructions to use this component ###
	@see https://air-datepicker.com/docs

	add these lines in client.js of project
		require('air-datepicker/air-datepicker.css');
		require('air-datepicker/air-datepicker');
		require('air-datepicker/locale/de');
*/
module.exports = {
	config: {
		forceFirstChangePropagation: false,
		fieldToModelDelay: 150, // if multiple picker value changes happen (e.g., if the time picker slider is used) this is the number of milliseconds to delay the actual form-field-change. if another change occurs within that time the first one will not be propagated and the timer starts again.
		momentDataDateFormat: '',
		momentDateFormat: 'DD.MM.YYYY',
		inheritDayOnTextInput: false, // e.g., if you need a time picker which shows times and sets full timestamps and the day should not change if the user changes the value via text input one may set this value to true.
		selectLastNrOfCharactersOnTabFocusIn: 0, // if one likes to see and manipulate a full dataset (e.g., date and time) but usually only needs to set the time this flag my decide how many characters at the very end of the text-input should be selected if a user tabs through the form. this is a convenience feature only. e.g., set this to 5 than show DD.MM.YYYY HH:mm but auto-select only HH:mm.
		airDatePicker: {
			language: 'de', // this field does not exist since the picker-update to 3.4.0 but is utilized via the keys of airDatepickerLocales var.
			dateFormat: 'dd.MM.yyyy',
			inline: false,
			autoClose: true,
			keyboardNav: false,
			// view: 'days', // days, months, years
			// minView: 'days', // days, months, years
            // hoursStep: 1,
            // minutesStep: 1,
			// timeFormat: 'HH:mm',
			// timepicker: true,
			// onlyTimepicker: true,
			// isMobile: false,

			// NOTE: event methods (like onSelect, onHide, ...) will be bound in onBuild() to conserve "this" as this component.
		},
		// inputSize: 20, // size attribute of input type text
	},

	model: {
		initDate: null,
		visible: false,
		titleKey: '',
		grantViewDateReset: true,
	},

	events: {
		// change all necessary values in case of changing the textboxes' date-value manually
		textChange: {
			type: 'change',
			selector: 'input',
			action: function(event){
				event.stopImmediatePropagation();

				const self = event.data.component;
				let $input, value, originalValue;
				if(
					($input = $(event.target)).length > 0 &&
					($input = $input.closest('input')).length > 0
				){
					originalValue = $input.val()
					value = self.getDataValue(originalValue, true)

					// set the date and select it
					if(value === false){
						// NOTE: may be here should be triggered some onInvalidDate on closest elements so the form may handle such errors.
						// NOTE: may be here an error should be thrown. depends on error handling.
						console.error('AirDateTimePicker: invalid date got @ "' + ((self.model || {}).fieldCode || '') + '": ' + $input.val())
					} else if(value === null){
						self.model.dp.date = value
						self.fieldToModel(value)
					} else {
						self.model.dp.date = new Date(value)
						// set new data directly to prevent issues when a user is pressing enter directly after changing the input field via keyboard.
						// NOTE: air-datepicker package needs some time to perform its usual events. if e.g., the modal where the form is located in triggers the form.submit() and modal.close() too soon the air-datepicker has no chance to react in time.
						self.fieldToModel(self.model.dp.date)
						self.model.dp.selectDate(new Date(value), { updateTime: self.config.airDatePicker.timepicker, silent: true })
					}
				}
			}
		},

		// open date-picker on click on icon
		toggle: {
			type: 'click',
			selector: '.datepicker-action-icon',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component
				if(!self.config.disabled){
					self.toggleCalendar();
				}
			}
		},

		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function(event){
				const self = event.data.component

				// prevent extra functionality if keyboardNav of airDatePicker is enabled to prevent interferences.
				if(!self.config.airDatePicker.keyboardNav && self.model.visible){
					const keyCode = utils.keyboard.getKeyCode(event)

					// set actual visible date within calendar as value in case there is none set already
					if(keyCode === 'enter' && !self.model.dataDATE){
						event.stopImmediatePropagation()
						event.stopPropagation()
						event.preventDefault()

						if(self.model.dp.viewDate){
							self.fieldToModel(self.model.dp.viewDate)
							self.setDate(self.model.dp.viewDate)
							self.model.dp.hide()
						}
					}
					// close on esc
					else if(keyCode === 'esc'){
						event.stopImmediatePropagation()
						event.stopPropagation()
						event.preventDefault()

						self.model.dp.hide()
					}
				}
			}
		},

		/**
		 * respect config flags on focus in
		 * @see config.selectLastNrOfCharactersOnTabFocusIn
		 */
		checkSelectionAfterFocus: {
			type: 'focusin',
			selector: 'input[type="text"]',
			action: function(event){
				const self = event.data.component

				if(self.config.selectLastNrOfCharactersOnTabFocusIn > 0){
					const $target = $(event.target).closest('input[type="text"]')
					if($target.length > 0){
						const target 	= $target[0]
						const len 		= Math.max(0, (target.selectionEnd || 0) - (target.selectionStart || 0))
						const value 	= $target.val()

						if(value && value.length && len === value.length && len > self.config.selectLastNrOfCharactersOnTabFocusIn){
							target.selectionStart = len - self.config.selectLastNrOfCharactersOnTabFocusIn
							target.selectionEnd = len
						}
					}
				}
			}
		}
	},

	methods: {
		onBuild(storage){
			utils.refReplace(
				this.config.airDatePicker,
				{
					// onBeforeSelect: ({date, datepicker}) => {
					// 	return true
					// },
					onSelect: ({date}) => {
						this.fieldToModel(date, this.config.fieldToModelDelay)
					},
					onShow: (isFinished) => {
						if(isFinished){
							this.model.visible = true;
						}
					},
					onHide: (isFinished) => {
						if(isFinished){
							this.model.visible = false;
						}
					}
				}
			)

			// sanitize config
			this.config.disabled =
				this.config.disabled ||
				(this.model.config || {}).disabled ||
				((this.formMapping || {}).fieldConfig || {}).disabled
			;

			if((this.model.config || {}).inputSize){
				this.config.inputSize = this.model.config.inputSize
			}
		},

		/**
		 * correct picker value according to stepping config.
		 *
		 * @param m		moment object
		 */
		correctByStepping(m){
			if(!m) return;

			// respect time steps after change
			const minutesStep = (this.config.airDatePicker || {}).minutesStep || 1
			const hoursStep = (this.config.airDatePicker || {}).hoursStep || 1
			const timePickerGranted = (this.config.airDatePicker || {}).timepicker
			if(!timePickerGranted){
				m.startOf('day')
			} else {
				if(minutesStep > 1){
					m.set({
						seconds: 0,
						milliseconds: 0
					})
					const additionalMinutes = m.minutes() % minutesStep
					if(additionalMinutes > 0){
						m.add(minutesStep - additionalMinutes, 'minutes').startOf('minute')
					}
				}
				if(hoursStep > 1){
					m.set({
						seconds: 0,
						milliseconds: 0
					})
					const additionalHours = m.hours() % hoursStep
					if(additionalHours > 0){
						m.add(hoursStep - additionalHours, 'hours').startOf('hour')
					}
				}
			}
		},

		/**
		 * this function returns the date in the wanted format used for backend. (this.config.momentDataDateFormat || ISO)
		 * invalid dates drives this function to return false. empty ones return null.
		 *
		 * @param date			Date || String || Moment || null || '' || false - wanted date
		 * @param returnISO		boolean - if this parameter is set to true the this.config.momentDataDateFormat flag will be ignored and the iso format will be returned instead.
		 * @returns false || null || String
		 */
		getDataValue: function(date, returnISO){
			let m;
			if(date instanceof Date || !utils.isEmpty(date)){
				if(typeof date === 'string') {
					m = moment(date, this.config.momentDateFormat)

					// inherit day if necessary
					if(this.config.inheritDayOnTextInput && this.model.initDate){
						this.inheritDay(this.model.initDate, m)
					}

				} else {
					m = moment(date);
				}
				if(!m.isValid()) return false;
			}
			else {
				date = null;
			}

			if(m){
				this.correctByStepping(m)

				this.updateTitle(m.format(this.config.momentDateFormat))
				if(this.config.momentDataDateFormat && !returnISO)	date = m.format(this.config.momentDataDateFormat);
				else 												date = m.format();
			}

			return date;
		},

		/**
		 * set the date part of the given source within the given target.
		 *
		 * @param source		moment
		 * @param target		moment
		 */
		inheritDay(source, target){
			if(source && target){
				const inheritFields = moment(source).toObject()
				utils.forEachReverse(inheritFields, (value, key) => {
					if(key !== 'years' && key !== 'months' && key !== 'date') {
						delete inheritFields[key]
					}
				})
				target.set(inheritFields)
			}
		},

		updateTitle: function(date){
			if(this.$){
				if(date){
					if(this.model.titleKey){
						this.$.attr('title', __(this.model.titleKey, { ts: date }));
					} else {
						this.$.attr('title', date || '');
					}
				} else {
					this.$.removeAttr('title');
				}
			}
		},

		setDate: function(date){
			if(date === null){
				this.model.dp.clear()
			} else {
				var m = moment(date)
				date = m.format()

				// set the date and select it
				this.updateTitle(m.format(this.config.momentDateFormat))
				this.model.dataDATE = date
				this.model.dp.date = new Date(date)
				this.model.dp.opts.autoClose = false
				this.model.dp.selectDate(new Date(date))
				this.model.dp.opts.autoClose = this.config.airDatePicker.autoClose
			}
		},

		/**
		 * tell the closest form that this form-field has been changed.
		 *
		 * @param delay int - how many ms to wait until fieldToModel should be done.
		 * 				NOTE: this is particularly useful when the timePicker-slider is used and many changes would cause many fieldToModel calls.
		 * @param date Date || String || Moment || false || null || ''
		 */
		fieldToModel: function(date, delay = 0){
			if(this.model.fieldToModelDelayTimeout){
				clearTimeout(this.model.fieldToModelDelayTimeout)
			}

			if(delay > 0){
				this.model.fieldToModelDelayTimeout = setTimeout(() => {
					this.fieldToModel(date)
				}, delay)
			} else {
				date = this.getDataValue(date);
				if(
					date !== false
					&&
					(this.model.dataDATE || date)
					&&
					(
						this.config.forceFirstChangePropagation
						||
						(!this.model.dataDATE && date)
						||
						(this.model.dataDATE && !date)
						||
						(this.config.momentDataDateFormat && moment(this.model.dataDATE, this.config.momentDataDateFormat).diff(moment(date, this.config.momentDataDateFormat)) !== 0)
						||
						(!this.config.momentDataDateFormat && moment(this.model.dataDATE).diff(moment(date)) !== 0)
					)
				){
					this.config.forceFirstChangePropagation = false;
					this.model.dataDATE = date;

					// in rare cases the date may be manipulated from outside the picker itself (e.g., duration field) to a value not corrected properly (e.g., by stepping caused by round-off errors or wrong user inputs)
					// in these cases the date picker's value has to be updated too.
					if(date && this.model.dp.date && date != this.model.dp.date){
						this.model.dp.date = new Date(date)
						this.model.dp.opts.autoClose = false
						this.model.dp.selectDate(new Date(date), { updateTime: this.config.airDatePicker.timepicker, silent: true })
						this.model.dp.opts.autoClose = this.config.airDatePicker.autoClose
					}

					// update date
					this.triggerClosest('onChildChanged', {
						fieldCode: this.model.fieldCode,
						value: date
					});

				}
			}

		},

		/**
		 * this function is used to show or hide the calendar according to if its visible or not.
		 */
		toggleCalendar: function(){
			if(this.model.visible) 	this.model.dp.hide();
			else 					this.model.dp.show();
		},

		onBeforeAttach: function(){
			// NOTE: overwrite this method if necessary
		}
	},

	hooks: {
		attach: function($element, options){
			if(options.refresh) return;

			// merge config given by template-atom-config into real config
			utils.refMerge(this.config, this.model.config);
			var config = this.config.airDatePicker;

			this.onBeforeAttach();

			// estimate init date
			let actualDate = null;
			if(this.model.dataDATE !== undefined){
				if(this.model.dataDATE !== null) {
					actualDate = moment(this.model.dataDATE)
				}
			}
			else if(this.config.initDate){
				if(this.config.initDate === 'now') 			actualDate = moment();
				else 										actualDate = moment(this.config.initDate);
				if(this.config.initDateStartOf) 			actualDate = actualDate.startOf(this.config.initDateStartOf)
				else if(this.config.initDateEndOf) 			actualDate = actualDate.endOf(this.config.initDateEndOf)

				if(this.config.initDateModification){
					var d;
					for (d in this.config.initDateModification.diff || {}){
						actualDate = actualDate.add(this.config.initDateModification.diff[d], d);
					}
				}
			}

			if(this.config.minDate){
				var minDate;
				if(actualDate) 	minDate = actualDate.clone();
				else 			minDate = moment();

				if(this.config.minDate.startOf){
					minDate = minDate.startOf(this.config.minDate.startOf);
				}
				if(this.config.minDate.endOf){
					minDate = minDate.endOf(this.config.minDate.endOf);
				}
				config.minDate = minDate.toDate();
			}
			if(this.config.maxDate){
				var maxDate;
				if(actualDate) 	maxDate = actualDate.clone();
				else 			maxDate = moment();

				if(this.config.maxDate.startOf){
					maxDate = maxDate.startOf(this.config.maxDate.startOf);
				}
				if(this.config.maxDate.endOf){
					maxDate = maxDate.endOf(this.config.maxDate.endOf);
				}
				config.maxDate = maxDate.toDate();
			}

			// init
			var fieldDefaultValue = '';
			var inputElement = $element.find('input');

			this.correctByStepping(actualDate)

			// NOTE: it is mandatory to provide the defaultDate config parameter as moment-instance in case of format and or locale usage.
			if(actualDate && actualDate !== null){
				// initDate is necessary for day inheritance feature.
				this.model.initDate = actualDate.clone()
				// add start-date to config
				config.startDate = new Date(actualDate.format())
				// set field-value
				fieldDefaultValue = actualDate.format(this.config.momentDateFormat);
			}
			// set startDate of picker anyway in case one uses one of the stepping features.
			else {
				const viewDate = moment()
				this.correctByStepping(viewDate)
				config.startDate = new Date(viewDate.format())
			}

			// set locale
			if(config.language && airDatepickerLocales[config.language]){
				config.locale = airDatepickerLocales[config.language]
			}

			// set value to input field and prepare air-picker
			this.model.dp = new AirDatepicker(inputElement.val(fieldDefaultValue)[0], config)

			// if a start date is given
			if(actualDate && actualDate !== null){

				// set the date and select it
				this.updateTitle(fieldDefaultValue);
				this.model.dp.date = new Date(actualDate.format());
				this.model.dp.selectDate(new Date(actualDate.format()));
			}
		}
	}
};
